<script>
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'Parameters',
  data() {
    return {
      startDateMenu: false,
      valid: true,
      endDateMenu: false,
      dateWasChanged: false,
      item: {
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        selected_time: {
          code: 'measureTime',
          name: this.$t('label__measureTime'),
        },
        period: '15min',
        useStartDateTime: true,
        useEndDateTime: true,
      },
      rules: {
        selected_time: [x => !!x || this.$t('validation__is_required')],
      },
      firstDayOfWeek: 1,
      modelName: 'events',
      dateTimeType: [
        { code: 'measureTime', name: this.$t('label__measureTime') },
        { code: 'receiveTime', name: this.$t('label__receiveTime') },
      ],
    }
  },
  computed: {
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    locale() {
      return this.$i18n.locale === 'ch' ? 'zh' : this.$i18n.locale
    },
    startDateTime() {
      return (
        this.item.start_date +
        (this.item.start_time ? ' ' + this.item.start_time : '')
      )
    },
    endDateTime() {
      return (
        this.item.end_date +
        (this.item.end_time ? ' ' + this.item.end_time : '')
      )
    },
  },
  watch: {
    startDateMenu: function(newVal, oldVal) {
      if (!newVal && this.dateWasChanged) {
        this.item.period = null
      }
    },
    endDateMenu: function(newVal, oldVal) {
      if (!newVal && this.dateWasChanged) {
        this.item.period = null
      }
    },
  },
  mounted() {
    this.firstDayOfWeek = this.unitsMeasurement.firstDayOfWeek
    let settingsFromStore = this.getSettingsFromStore()
    if (!settingsFromStore) {
      const now = moment(new Date())
      let last15Min = moment(new Date()).subtract(15, 'minutes')
      this.item = {
        ...this.item,
        start_date: last15Min.format('YYYY-MM-DD'),
        start_time: last15Min.format('H:mm'),
        end_date: now.format('YYYY-MM-DD'),
        end_time: now.format('H:mm'),
        period: '15min',
      }
    } else {
      if (!settingsFromStore.period) {
        this.item.period = null
      }
      this.item = settingsFromStore
    }
    this.confirm()
  },
  methods: {
    setSettingsInStore() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.modelName,
        params: cloneDeep(this.item),
      })
    },
    getSettingsFromStore() {
      return this.$store.state.settings.settings[this.modelName]
    },
    confirm(clicked) {
      if (this.$refs.timeForm.validate()) {
        this.updatePeriodRange()
        this.setSettingsInStore()
        this.$emit('set-params', { ...this.item, clicked: clicked })
      }
    },
    dateCheckboxClickHandler() {
      const now = moment(new Date())
      if (!this.item.useStartDateTime) {
        this.dateWasChanged = true
        this.item.period = null
        this.item.start_date = ''
        this.item.start_time = ''
      }
      if (!this.item.useEndDateTime) {
        this.dateWasChanged = true
        this.item.period = null
        this.item.end_date = ''
        this.item.end_time = ''
      }
      if (this.item.useStartDateTime && this.item.start_date === '') {
        this.item.start_date = now.format('YYYY-MM-DD')
        this.item.start_time = '00:00'
      }
      if (this.item.useEndDateTime && this.item.end_date === '') {
        this.item.end_date = now.format('YYYY-MM-DD')
        this.item.end_time = '23:59'
      }
    },
    onEndDateClickHandler() {
      this.item.useEndDateTime = true
      if (!this.item.end_time || this.item.end_time === '') {
        this.item.end_time = '23:59'
      }
      if (!this.item.end_date || this.item.end_date === '') {
        this.item.end_date = moment(new Date()).format('YYYY-MM-DD')
      }
    },
    onStartDateClick() {
      this.item.useStartDateTime = true
      if (!this.item.start_time || this.item.start_time === '') {
        this.item.start_time = '00:00'
      }
      if (!this.item.start_date || this.item.start_date === '') {
        this.item.start_date = moment(new Date()).format('YYYY-MM-DD')
      }
    },
    updatePeriodRange() {
      let now = moment(new Date())
      if (this.item.period) {
        this.item.useStartDateTime = true
        this.item.useEndDateTime = true
        this.item.end_date = now.format('YYYY-MM-DD')
        this.item.end_time = now.format('H:mm')
        switch (this.item.period) {
          case '15min': {
            now.subtract(15, 'minutes')
            this.item.start_date = now.format('YYYY-MM-DD')
            this.item.start_time = now.format('H:mm')
            break
          }
          case 'today': {
            this.item.start_date = now.format('YYYY-MM-DD')
            this.item.start_time = '00:00'
            this.item.end_time = '23:59'
            break
          }
          case 'yesterday': {
            now.subtract(1, 'days')
            this.item.start_date = now.format('YYYY-MM-DD')
            this.item.start_time = '00:00'
            this.item.end_date = now.format('YYYY-MM-DD')
            this.item.end_time = '23:59'
            break
          }
          case '7days': {
            now.subtract(7, 'days')
            this.item.start_date = now.format('YYYY-MM-DD')
            this.item.start_time = '00:00'
            this.item.end_time = '23:59'
            break
          }
        }
      }
    },
  },
}
</script>

<template>
  <v-container
    fluid
    grid-list-xs
  >
    <v-form
      ref="timeForm"
      v-model="valid"
      lazy-validation>
      <v-layout
        row
        wrap
      >
        <v-flex
          md3
          xs12>
          <v-layout 
            :class="$style.alignCheckbox">
            <div>
              <v-checkbox 
                v-model="item.useStartDateTime"
                class="mr-1"
                @change="dateCheckboxClickHandler"/>
            </div>
            <v-flex>
              <v-menu
                ref="startDateMenu"
                :close-on-content-click="false"
                v-model="startDateMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="startDateTime"
                  :label="$t('label__start_date')"
                  append-icon="event"
                  readonly
                  @click="onStartDateClick"
                />
                <v-date-picker
                  v-model="item.start_date"
                  :max="item.end_date"
                  :first-day-of-week="firstDayOfWeek"
                  :locale="locale"
                  class="datePicker"
                  @input="startDateMenu=true"
                  @change="dateWasChanged=true"
                />
                <v-time-picker
                  v-model="item.start_time"
                  format="24hr"
                  @change="startDateMenu=false, dateWasChanged=true"
                  @update:period="dateWasChanged=true"
                />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          md3
          xs12
        >
          <v-layout
            :class="$style.alignCheckbox">
            <div>
              <v-checkbox 
                v-model="item.useEndDateTime"
                class="mr-1"
                @change="dateCheckboxClickHandler"/>
            </div>
            <v-flex>
              <v-menu
                ref="endDateMenu"
                :close-on-content-click="false"
                v-model="endDateMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="endDateTime"
                  :label="$t('label__end_date')"
                  append-icon="event"
                  readonly
                  @click="onEndDateClickHandler"
                />
                <v-date-picker
                  v-model="item.end_date"
                  :min="item.start_date"
                  :first-day-of-week="firstDayOfWeek"
                  :locale="locale"
                  class="datePicker"
                  @input="endDateMenu=true"
                  @change="dateWasChanged=true"
                />
                <v-time-picker
                  v-model="item.end_time"
                  format="24hr"
                  @change="endDateMenu=false, dateWasChanged=true"
                  @update:period="dateWasChanged=true"
                />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          md3
          xs12>
          <v-select
            v-model="item.selected_time"
            :items="dateTimeType"
            :rules="rules.selected_time"
            :label="$t(`label__time`)"
            item-text="name"
            item-value="code"
            clearable
            return-object
            required
          />
          <v-spacer/>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout
      row
      wrap
    >
      <v-flex
        md4
        xs12
      >
        <v-btn-toggle
          v-model="item.period"
          @change="updatePeriodRange"
        >
          <v-btn
            :value="'15min'"
            flat
          >
            {{ $t('label__last_15_minutes') }}
          </v-btn>
          <v-btn
            :value="'today'"
            flat
          >
            {{ $t('label__today') }}
          </v-btn>
          <v-btn
            :value="'yesterday'"
            flat
          >
            {{ $t('label__yesterday') }}
          </v-btn>
          <v-btn
            :value="'7days'"
            flat
          >
            {{ $t('label__last_7_days') }}
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
    >
      <v-flex
        md3
        xs12
      >
        <v-btn
          :disabled="!valid"
          color="primary"
          block
          @click="confirm(true)"
        >
          {{ $t('buttons__apply') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.alignCheckbox {
  align-items: flex-end;
}
</style>
